module.exports = __webpack_public_path__ + "static/media/STREAMER.f13fb967.svg";